<template>
  <div class="agent-index-page">
    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">代理系统</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="agent-menu">
        <div class="menu-item" v-for="(item,index) in list" :key="index" @click="jumpPage(item.path)">
          <img :src="item.icon" class="icon" alt="">
          <div class="title">{{item.title}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'agent-index',
  data(){
    return {
      list: [
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "下属代理",
          path: '/agent-subAgent'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "代理总览",
          path: '/agent-overview'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "直属玩家",
          path: '/agent-directPlayers'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "盈亏统计",
          path: '/agent-statistics'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "账单查询",
          path: '/agent-bills'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "充值记录",
          path: '/agent-recharge'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "提现记录",
          path: '/agent-withdraw'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "个人信息",
          path: '/agent-info'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "下级在线",
          path: '/agent-subOnline'
        },
        {
          icon: require('../../../static/img/ng/qb.png'),
          title: "赠送记录",
          path: '/agent-giveAway'
        }
      ]
    }
  },
  mounted() {

  },
  methods: {
    back(){
      window.history.go(-1)
    },
    jumpPage(path) {
      this.$router.push({ path: path });
    }
  },
}
</script>

<style scoped lang="scss">
.agent-index-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction:column;
  overflow: hidden;
  background: #131313;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.50667rem;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }

  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 2;
    padding-top: .2rem;
    .agent-menu {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 .3rem;
      .menu-item {
        width: calc(100% / 3);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: .4rem;
        .icon {
          width: 1.5rem;
        }
        .title {
          font-size: .32rem;
          color: #ccc;
          margin-top: .3rem;
          text-align: center;
          height: .8rem;
          line-height: .4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/index.vue